import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, forwardRef } from "react";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
export function DividerItems(props) {
    const { children, divider = true, dividerStart, dividerEnd } = props;
    let first = true;
    return (_jsxs(_Fragment, { children: [dividerStart && _jsx(Divider, {}), divider
                ? Children.map(children, node => {
                    if (!node)
                        return node;
                    const divider = !(first || node.props?.hideDivider);
                    first = false;
                    return (_jsxs(_Fragment, { children: [divider && _jsx(Divider, {}), node] }));
                })
                : children, dividerEnd && _jsx(Divider, {})] }));
}
DividerItems.displayName = "DployDividerItems";
export const DividerList = forwardRef((props, ref) => {
    const { children, divider = true, dividerStart, dividerEnd, ...rest } = props;
    return (_jsx(List, { ...rest, ref: ref, children: _jsx(DividerItems, { divider: divider, dividerStart: dividerStart, dividerEnd: dividerEnd, children: children }) }));
});
DividerList.displayName = "DployDividerList";
//# sourceMappingURL=DividerList.js.map